import React, { Component } from "react";

import "react-datepicker/dist/react-datepicker.css";
import API from "../../../apiService.js";
import ALERT from "../../component/Alert";

export class Subjektif extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anamnese: props.inpatient.anamneses[0]
        ? props.inpatient.anamneses[0].anamnese
        : "",
      eval: props.inpatient.anamneses[0] ? props.inpatient.anamneses[0].eval : "0",
      id: props.inpatient.anamneses[0] ? props.inpatient.anamneses[0].id : "",
      nursing_anamnese: props.inpatient.anamneses[0]
        ? props.inpatient.anamneses[0].nursing_anamnese
        : "-",
      treat: props.inpatient.anamneses[0]
        ? props.inpatient.anamneses[0].treat
        : "-",
      visit_id: props.visit_id,
      visit_inpatient_detail_id: props.inpatient.id ?? "0",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.inpatient !== prevProps.inpatient) {
      this.setState({
        anamnese: this.props.inpatient.anamneses[0]
            ? this.props.inpatient.anamneses[0].anamnese
            : "",
        eval: this.props.inpatient.anamneses[0] ? this.props.inpatient.anamneses[0].eval : "0",
        id: this.props.inpatient.anamneses[0] ? this.props.inpatient.anamneses[0].id : "",
        nursing_anamnese: this.props.inpatient.anamneses[0]
            ? this.props.inpatient.anamneses[0].nursing_anamnese
            : "-",
        treat: this.props.inpatient.anamneses[0]
            ? this.props.inpatient.anamneses[0].treat
            : "-",
        visit_id: this.props.visit_id,
        visit_inpatient_detail_id: this.props.inpatient.id ?? "0",
      })
    }
  }

  handleTextChange = (e) => {
    let anamneses = [];
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        anamneses = { data: [this.state], param: "anamneses" };
        // console.log(this.state);
        // this.props.parentCallback(anamneses);
      }
    );
  };

  handleSubmit = (e) => {
    if (this.state.id > 0) {
      this.PutData();
    } else {
      this.PostData();
    }
    this.props.nextTab();
  };

  PostData = async () => {
    const res = await API.post("management/anamneses/create", {...this.state, inpatient_room_id: this.props.inpatient.inpatient_room_id});
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      this.props.on_data_saved(res.data)
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  PutData = async () => {
    var param = this.state;
    const res = await API.put("management/anamneses/update", param);
    if (res.code === 200) {
      ALERT("success", "Berhasil Menyimpan Data ");
      this.props.on_data_saved(res.data)
    } else {
      ALERT("error", "gagal menyimpan data");
    }
  };

  onReload = () => {
    this.props.history.push("/pelayanan-ranap");
  };

  render() {
    // console.log(this.props.inpatient);
    return (
      <>
        <div className="form-group row">
          <label
            htmlFor="example-text-input"
            className="col-md-5 col-form-label col-form-label-sm"
          >
            Anamnese
          </label>
          <div className="col-md-7">
            <div className="row">
              <textarea
                className="form-control form-control-sm"
                type="text"
                placeholder="Keluhan Pasien"
                name="anamnese"
                onChange={this.handleTextChange}
                value={this.state.anamnese}
              />
            </div>
          </div>
        </div>

        <button className="btn btn-primary" onClick={this.handleSubmit} disabled={this.props.disabled}>
          Simpan
        </button>
        <button className="btn btn-danger" onClick={this.onReload}>
          Tutup
        </button>
      </>
    );
  }
}

export default Subjektif;
